import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IBoarwalkCrosssellData } from 'src/app/domain/interfaces/crossell/interface-cross-sell-component';
import { EBoardwalkPage } from 'src/app/domain/models/crossell/boardwalk-page-enum';
import { ScriptService } from 'src/app/infraestructure/services-views/script-service/script.service';
import { ScriptsIds } from 'src/app/domain/models/scripts/scripts-ids';
import { CrossSellsService } from 'src/app/infraestructure/drive-adapter/crossell-service/cross-sells.service';
import { Subscription } from 'rxjs';

declare global {
  interface Window {
    boardwalk: any;
  }
}

@Component({
  selector: 'app-boardwalk',
  templateUrl: './boardwalk.component.html',
  styleUrl: './boardwalk.component.scss'
})
export class BoardwalkComponent implements OnInit {
  public PageBoardwalkData!: IBoarwalkCrosssellData;
  @Input() BoardwalkPageType!: EBoardwalkPage | string;
  @Input() boardwalkPath?: string | null = null;
  public createStylesElement!: any;
  public crossSellsServiceSubscription!: Subscription;

  constructor(private scriptService: ScriptService, private renderer: Renderer2, private crossSellsService: CrossSellsService) {
  }

  ngOnInit(): void {
    if (this.boardwalkPath) {
      this.BoardwalkPageType = EBoardwalkPage.DeclinePage;
      const boardwalkData: IBoarwalkCrosssellData = {
        boardwalkPath: "",
        pid: this.boardwalkPath,
        role: "path",
        root: "promenade"
      }
      this.showbBoardwalkPath(boardwalkData);
    } else {
          this.crossSellsServiceSubscription = this.crossSellsService.getBoardwalkCrossSells(this.BoardwalkPageType).subscribe((res: IBoarwalkCrosssellData) => {
      this.showbBoardwalkPath(res);
    })
    }

  }

  showbBoardwalkPath(path: IBoarwalkCrosssellData) {
    this.PageBoardwalkData = { ...path, root: "promenade", role: "path" };
    window.boardwalk = this.PageBoardwalkData;
    window.boardwalk.immediate = true;
    this.scriptService.loadScript(ScriptsIds.Boardwalk, environment.BoardwalkIntegration.replace("{pid}", this.PageBoardwalkData?.pid).replace("{role}", this.PageBoardwalkData?.role));
    this.createStylesElement = this.renderer.createElement("link");
    this.renderer.setAttribute(this.createStylesElement, "rel", "stylesheet");
    this.renderer.setAttribute(this.createStylesElement, "type", "text/css");
    this.renderer.setAttribute(this.createStylesElement, "href", environment.UrlBucketDynamicCSSBoardwalk.replace("{PageType}", this.BoardwalkPageType));
    this.renderer.appendChild(document.head, this.createStylesElement);
  }

  ngOnDestroy(): void {
    this.crossSellsServiceSubscription?.unsubscribe();
    if (this.createStylesElement) {
      this.renderer.removeChild(document.head, this.createStylesElement);
    }
    window.boardwalk = undefined;
    this.scriptService.removeScript(ScriptsIds.Boardwalk);
  }
}
